// Goal Board data — committed ingest output (SYSTEM/kit-os/mirror/ingest-goals.py).
// Baked stamps drive the "current as of" line; render-layer staleness is a UI property.
import goalsData from "./goalsBoard.json";

// Owner-set freshness limits (council D1: never a silent frozen board).
export const GOALS_STALE_HOURS = 24; // banner turns amber
export const GOALS_DEAD_HOURS = 72; // "not checking right now" banner

export const CARDS = goalsData.cards; // rawState is baked by ingest
export const STAMP = goalsData.stamp;

// "current as of" = the ingest stamp; staleness = hours since ingest ran (render-layer).
export function boardClock(now = new Date()) {
  const ingested = new Date(STAMP.ingested_at);
  const hours = Math.max(0, (now.getTime() - ingested.getTime()) / 36e5);
  const fresh = hours <= GOALS_STALE_HOURS;
  const dead = hours > GOALS_DEAD_HOURS;
  const stampText = ingested.toLocaleString("en-US", {
    month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
  return { hours, fresh, dead, stampText };
}

export const DUSTING_LINE = "Needs dusting — hasn't moved in a while";